import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageTitle, Stat } from "@/components/app/ui";
import { api } from "@/lib/api";

export default function AdminOverview() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setS(r.data)); }, []);
  if (!s) return <div className="h-64 rounded-2xl bg-muted animate-pulse" />;
  return (
    <div data-testid="admin-overview-page">
      <PageTitle title="Admin console" copy="Manage companies, complimentary access, enquiries and payments.">
        <Link to="/admin/companies?new=1" className="btn-brand" data-testid="admin-add-company-btn">Add company</Link>
      </PageTitle>
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <Stat label="Companies" value={s.companies} testId="admin-stat-companies" color="#4f46e5" />
        <Stat label="Users" value={s.users} testId="admin-stat-users" color="#7c3aed" />
        <Stat label="Open enquiries" value={s.enquiries_open} testId="admin-stat-enquiries" color="#db2777" />
        <Stat label="Paid transactions" value={s.payments} testId="admin-stat-payments" color="#10b981" />
      </div>
      <div className="mt-6 grid lg:grid-cols-2 gap-6">
        <div className="card-box p-6"><h3 className="font-semibold">Revenue by currency</h3>
          <div className="mt-4 space-y-2">{Object.keys(s.revenue).length === 0 ? <p className="text-sm text-muted-foreground">No revenue yet</p> : Object.entries(s.revenue).map(([c, v]) => <div key={c} className="flex justify-between text-sm"><span>{c}</span><strong>{v.toLocaleString()}</strong></div>)}</div>
        </div>
        <div className="card-box p-6"><h3 className="font-semibold">Companies by plan</h3>
          <div className="mt-4 space-y-2">{Object.entries(s.plans).map(([p, n]) => <div key={p} className="flex justify-between text-sm capitalize"><span>{p}</span><strong>{n}</strong></div>)}</div>
        </div>
      </div>
    </div>
  );
}
